import React from "react";
import { Helmet } from "react-helmet";

const WebsiteTitle = ({ title }) => {
  return (
    <Helmet>
      <title>{title?.length ? "Recycling | " + title : "Recycling"}</title>
    </Helmet>
  );
};

export default WebsiteTitle;
